export interface MangaCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const mangaCategories: MangaCategory[] = [
  { slug: 'shonen', name: '少年漫画', description: '热血与友情的战斗故事', icon: 'ri-sword-line' },
  { slug: 'shojo', name: '少女漫画', description: '细腻浪漫的青春恋爱', icon: 'ri-heart-line' },
  { slug: 'seinen', name: '青年漫画', description: '深度剧情与成熟世界观', icon: 'ri-user-star-line' },
  { slug: 'fantasy', name: '奇幻冒险', description: '异世界与魔法冒险旅程', icon: 'ri-rocket-line' },
  { slug: 'comedy', name: '恋爱喜剧', description: '甜蜜搞笑的校园日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'mystery', name: '悬疑推理', description: '烧脑刺激的解谜之旅', icon: 'ri-search-eye-line' },
  { slug: 'horror', name: '恐怖惊悚', description: '令人毛骨悚然的故事', icon: 'ri-ghost-line' },
  { slug: 'slice-of-life', name: '日常治愈', description: '温暖人心的生活故事', icon: 'ri-sun-line' },
  { slug: 'action', name: '热血格斗', description: '拳拳到肉的激燃对决', icon: 'ri-fire-line' },
  { slug: 'sci-fi', name: '科幻未来', description: '未来世界的无限想象', icon: 'ri-planet-line' },
  { slug: 'history', name: '历史战国', description: '风云变幻的时代史诗', icon: 'ri-ancient-gate-line' },
  { slug: 'sports', name: '运动竞技', description: '挥洒汗水的青春赛场', icon: 'ri-basketball-line' },
];

export const categorySlugMap: Record<string, string> = {
  '少年漫画': 'shonen',
  '少女漫画': 'shojo',
  '青年漫画': 'seinen',
  '奇幻冒险': 'fantasy',
  '恋爱喜剧': 'comedy',
  '悬疑推理': 'mystery',
  '恐怖惊悚': 'horror',
  '日常治愈': 'slice-of-life',
  '热血格斗': 'action',
  '科幻未来': 'sci-fi',
  '历史战国': 'history',
  '运动竞技': 'sports',
};